import { z } from 'zod'

// PROVISOIRE — seul `expires_at` est un nom de champ confirmé littéralement
// par MEC-3249. Les autres sont déduits des colonnes DB citées par MEC-3246
// (reports.report_type, reports.generated_at ; nom assureur/fichier non
// nommés explicitement côté JSON dans le ticket). À corriger dès que
// MEC-3246 est livré et que le vrai payload est observable.
export const ReportVerifySchema = z.object({
  report_type: z.string(),
  report_type_localizations: z.record(z.string(), z.string()).optional(),
  insurer_name: z.string(),
  generated_at: z.string(),
  expires_at: z.string(),
  file_name: z.string(),
})

export type ReportVerifyResult = z.infer<typeof ReportVerifySchema>

// Search params of the public /report link. `src` is the recipient's email;
// the unicode pattern keeps accented addresses (josé@exemple.ca) valid, which
// Zod's default email pattern rejects.
export const reportSearchSchema = z.object({
  t: z.string().min(1),
  src: z.email({ pattern: z.regexes.unicodeEmail }),
})

export class ReportApiError extends Error {
  readonly status: number

  constructor(status: number, message: string) {
    super(message)
    this.name = 'ReportApiError'
    this.status = status
  }
}
